var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValue3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6840_126772)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 60,
    r: 20,
    fill: "#F3A218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 40H40L0 0V40Z",
    fill: "#0F973D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 80H80L40 40V80Z",
    fill: "#134AB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6840_126772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue3);
export default __webpack_public_path__ + "static/media/value3.a7ff2ccb8ecb97a8508ef808f235d261.svg";
export { ForwardRef as ReactComponent };